import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface CookieBannerProps {
  onOpenPrivacy: () => void;
}

export const CookieBanner: React.FC<CookieBannerProps> = ({ onOpenPrivacy }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('vidly_cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('vidly_cookie_consent', 'all');
    setShow(false);
  };

  const handleNecessaryOnly = () => {
    localStorage.setItem('vidly_cookie_consent', 'necessary');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 p-4 rounded-xl border border-zinc-800 bg-[#0e0e11]/95 backdrop-blur-md shadow-xl text-xs text-left space-y-2.5">
      <div className="flex items-center justify-between">
        <span className="font-medium text-white text-xs">
          Privacidad & Cookies
        </span>
        <button
          onClick={handleNecessaryOnly}
          className="text-zinc-500 hover:text-zinc-300 p-0.5"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      <p className="text-zinc-400 text-[11px] leading-relaxed">
        Utilizamos cookies técnicas para la sesión y cookies publicitarias (Google AdSense) para financiar el acceso gratuito. Puedes aceptar todas o limitarte a las técnicas necesarias.
      </p>

      <div className="flex items-center justify-between pt-1">
        <button
          onClick={onOpenPrivacy}
          className="text-zinc-400 hover:text-white underline underline-offset-4 text-[11px]"
        >
          Política de cookies
        </button>

        <div className="flex items-center gap-1.5">
          <button
            onClick={handleNecessaryOnly}
            className="px-2.5 py-1 rounded-lg border border-zinc-800 text-zinc-400 hover:text-white hover:bg-zinc-800 text-[11px] font-medium transition-colors"
          >
            Técnicas
          </button>
          <button
            onClick={handleAcceptAll}
            className="btn-primary text-[11px] py-1 px-3"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};
